import { Link } from "react-router-dom";
import { Badge, GoldButton, OutlineGoldButton } from "../funnel";
import { useCountdown, pad } from "../funnel/Countdown";
import { REPLAY_DEADLINE } from "../../config/event";
import { scrollToId } from "../../lib/scroll";

const DeadlineBar = () => {
  const t = useCountdown(REPLAY_DEADLINE);
  return (
    <div className="banner-sweep relative overflow-hidden border-b border-[rgba(232,184,74,0.35)] bg-[linear-gradient(180deg,#1a160f,#060606)]" data-testid="replay-deadline-bar">
      <p className="gutter flex h-10 items-center justify-center gap-2 whitespace-nowrap text-[12.5px] text-[#efe6d1] sm:gap-3 sm:text-sm" role="timer" aria-label="Time until the replay comes down">
        <span>This replay comes down in</span>
        <span className="font-mono-plex font-semibold tabular-nums text-[var(--gold)]" data-testid="replay-countdown">{`${t.days}d ${pad(t.hours)}h ${pad(t.min)}m ${pad(t.sec)}s`}</span>
      </p>
    </div>
  );
};

const ReplayHeader = () => (
  <header className="border-b border-[rgba(232,184,74,0.18)] bg-[#0a0a0a]/90 backdrop-blur-md" data-testid="site-header">
    <div className="gutter flex h-16 flex-nowrap items-center justify-between gap-2 sm:h-[71px] sm:gap-3">
      <Link to="/replay" className="flex min-w-0 items-center gap-2 sm:gap-3" data-testid="header-brand-link">
        <Badge size={40} className="sm:!h-12 sm:!w-12" />
        <span className="font-display gold-text text-[14px] leading-[0.95] tracking-[0.04em] sm:whitespace-nowrap sm:text-[22px]">
          <span className="block sm:inline">EDUCATE II</span> <span className="block sm:inline">ELEVATE</span>
        </span>
      </Link>
      <div className="flex shrink-0 items-center gap-1.5 sm:gap-3">
        <OutlineGoldButton as={Link} to="/apply" className="whitespace-nowrap !px-3 !py-2 !text-[11.5px] sm:!px-5 sm:!text-[13px]" data-testid="header-book-call-button">Book a call</OutlineGoldButton>
        <GoldButton size="sm" onClick={() => scrollToId("enroll")} className="!px-3 sm:!px-5" data-testid="header-enroll-button">Enroll now</GoldButton>
      </div>
    </div>
  </header>
);

export const ReplayTop = () => (
  <>
    <DeadlineBar />
    <ReplayHeader />
  </>
);
